module.exports = __webpack_public_path__ + "img/imgZXGH(4).c95f836b.png";